import { css } from '@emotion/react';

export const loading = css`
  position: fixed;
`;
